import { distance } from "@turf/turf";
import { toLonLat } from "ol/proj";

const distanceBetweenTwoPoints = (point1: number[], point2: number[]) => {
  return distance(toLonLat(point1), toLonLat(point2));
};

export default distanceBetweenTwoPoints;
